import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Loader from '../../../common/Loader';
import { clearBillingReport } from '../../../../actions';
import BillingSummaryByDocumentGrid from './BillingSummaryByDocumentGrid';
import BillingDonutChart from './BillingDonutChart';

export const BillReportSummaryByDocumentResult = ({
  dispatchClearBillingReport,
  billings,
  loading,
}) => {
  useLayoutEffect(() => () => dispatchClearBillingReport(), []);

  if (loading) return <Loader />;
  if (!billings) return null;

  const rows = billings.get('rows') || [];
  const electronicTotal = billings.get('electronicTotal') || {};

  const totalDocs = Number(electronicTotal.documentCount || 0);
  const successDocs = Number(electronicTotal.documentCountSucess || 0);

  const totalAmount = Number(electronicTotal.totalAmount || 0);
  const successAmount =
    totalDocs > 0 ? (successDocs / totalDocs) * totalAmount : 0;

  const fmtMoney = (n) =>
    Number(n || 0).toLocaleString('es-PE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const fmtCount = (n) =>
    Number(n || 0).toLocaleString('es-PE', {
      maximumFractionDigits: 0,
    });

  return (
    <div className="mt-3">
      <BillingSummaryByDocumentGrid
        rows={rows}
        electronicTotal={electronicTotal}
      />

      <div className="row mt-4">
        <div className="col-12 col-lg-6 mb-4 d-flex justify-content-center">
          <BillingDonutChart
            total={totalDocs}
            success={successDocs}
            label="CP con Inconsistencias (Cantidad de CP)"
            formatValue={fmtCount}
          />
        </div>

        <div className="col-12 col-lg-6 mb-4 d-flex justify-content-center">
          <BillingDonutChart
            total={totalAmount}
            success={successAmount}
            label="CP con Inconsistencias (Monto de CP)"
            formatValue={fmtMoney}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: AccountingUnit.Billing.getIn(['report', 'loading']),
  billings: AccountingUnit.Billing.getIn(['report', 'content']),
});

BillReportSummaryByDocumentResult.propTypes = {
  billings: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchClearBillingReport: PropTypes.func.isRequired,
};

BillReportSummaryByDocumentResult.defaultProps = {
  loading: false,
  billings: null,
};

const mapDispatchToProps = {
  dispatchClearBillingReport: clearBillingReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BillReportSummaryByDocumentResult);
